export const ParseTtime = value => Number(value);
